<template lang="html">
  <div
    v-if="resource.columns && resource.columns.title && resource.columns.answer"
    class="accordion-item"
    :class="{'accordion-item--open': isOpen}"
  >
    <div
      v-editable="resource.columns.title"
      class="accordion-item__question"
    />
    <div
      ref="answer"
      class="accordion-item__answer"
    >
      <div v-editable="resource.columns.answer" />
    </div>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [ editable ],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isOpen () {
      if (this.isOpen) {
        this.$refs.answer.style.height = 'auto'
        const height = this.$refs.answer.offsetHeight
        this.$refs.answer.style.height = '0'
        window.setTimeout(() => {
          this.$refs.answer.style.height = `${height}px`
        }, 50)
      } else {
        this.$refs.answer.style.height = '0'
      }
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/zindex';
@import 'beisheim/scss/font';
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/grid';

.accordion-item {
  position: relative;
  border-top: 1px solid #D8D8D8;
  padding: scale(8) 0;
  @include grid-spacing(padding-left, 2);

  @include from(4) {
    @include grid-spacing(padding-left, 1);
  }

  &:before {
    content: '';
    cursor: pointer;
    position: absolute;
    display: block;
    left: 0;
    top: 2.85rem;
    height: 10px;
    width: 10px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    transition: 150ms ease-in-out all;
  }

  &--open {
    &:before {
      transform: rotate(135deg);
    }
    .accordion-item__answer {
      margin-top: scale(4);
    }
  }

  &:last-child {
    border-bottom: 1px solid #D8D8D8;
  }

  &__question {
    font-size: font-size(1);
    cursor: pointer;
  }

  &__answer {
    height: 0;
    overflow: hidden;
    transition: height 250ms ease-in-out, margin-top 250ms ease-in-out;

    @include from(4) {
      @include grid-spacing(padding-right, 5);
    }

    a {
      border-bottom: solid 1px gray(1);
    }

    p {
      margin-bottom: scale(4);
    }

    ul {
      list-style-type: disc;
      padding-left: scale(3);
      line-height: 1.6;
    }
  }
}

</style>
